import { Link, useNavigate } from "react-router-dom";
import FavouriteIcon from "./FavouriteIcon";
import { useDispatch } from "react-redux";
import { setBacklink } from "../redux/backlinkSlice";
import { useTranslation } from "react-i18next";
import { use } from "i18next";
import { useEffect, useState } from "react";

const ActivityCard = ({ activityData }) => {
    const { t, i18n } = useTranslation();
    // Gestisco il click sulla card
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handleCardClick = () => {
        navigate(`/activity-details?id=${activityData._id}`)
    }

    return (
        <div className="shadow-md flex flex-col w-full md:w-[240px] rounded-xl overflow-hidden transition-transform duration-500 ease-in-out transform md:hover:scale-105 cursor-pointer">

            {/* Photo cover */}
            <div className={`w-full h-[300px] md:h-[200px] overflow-hidden relative ${!activityData.coverImageUrl && 'bg-slate-300'}`}>
                {activityData.coverImageUrl && <img src={activityData.coverImageUrl.resizedUrl} alt={activityData.title} className={`object-cover w-full h-full rounded-xl}`} />}
                {/* Questi overlay andrebbero sostituiti con uno stop alla propagazione del click su Likeelement */}
                <div onClick={handleCardClick} className="absolute top-0 right-0 bottom-14 md:bottom-8 left-0"></div>
                <div onClick={handleCardClick} className="absolute top-0 right-14 md:right-8 bottom-0 left-0"></div>
                <div className="absolute right-2 bottom-2 z-10">
                    <FavouriteIcon activityId={activityData._id} />
                </div>
                <div className={`
                        absolute bottom-2 left-2
                        w-fit text-white
                        text-xs py-0.5 px-1
                        flex items-center gap-1
                    `}>
                    {
                        activityData.difficultyLevel.map((level, index) => (
                            <div key={index} className={`py-0.5 px-1 rounded-md ${level === 'Facile' ? 'bg-green-500' : level === 'Medio' ? 'bg-yellow-500' : level === 'Difficile' ? 'bg-red-500' : ''}`}>{level}</div>
                        ))
                    }
                </div>
            </div>

            {/* Info */}
            <div className="flex-grow flex flex-col gap-2 p-2 cursor-pointer" onClick={handleCardClick}>
                {/* Title */}
                <h4 className="leading-tight text-neutral-700 text-[1.2rem]">{activityData.title}</h4>
                {/* Details */}
                <div className="flex flex-col md:text-sm text-neutral-500">
                    <div className="flex gap-2 items-center"><div className="pt-[5px]"><i className="fi fi-rr-marker"></i></div>{activityData.selectedRegion}</div>
                    {/* Gratuita */}
                    {
                        !activityData.isExternalPaid &&
                        !activityData.isPremium &&
                        <div className="flex gap-2 items-center"><div className="pt-[5px]"><i className="fi fi-rr-credit-card"></i></div>{t('ActivityCard.free')}</div>
                    }
                    {/* A pagamento */}
                    {
                        !activityData.isExternalPaid &&
                        activityData.isPremium &&
                        activityData.price.length > 0 &&
                        <div className="flex gap-2 items-center"><div className="pt-[5px]"><i className="fi fi-rr-credit-card"></i></div>{`${t('ActivityCard.from')} ${activityData.price[0].value} CHF`}</div>
                    }
                    {/* A pagamento esterno */}
                    {
                        activityData.isExternalPaid &&
                        <div className="flex gap-2 items-center"><div className="pt-[5px]"><i className="fi fi-rr-credit-card"></i></div>{t('ActivityCard.isExternalPaid')}</div>
                    }
                </div>
            </div>

        </div >
    )
}

export default ActivityCard;